module.exports = __webpack_public_path__ + "static/media/icon-sel-device-click.9f689959.png";